"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscribeWidgetMap = void 0;
const lodash_1 = require("lodash");
const core_1 = require("../core");
const datasheet_map_1 = require("./datasheet_map");
const subscribeWidgetMap = (store, datasheetService) => {
    let widgetIds = new Set();
    return store.subscribe(() => {
        var _a;
        const state = store.getState();
        const widgetMap = state.widgetMap;
        if (!widgetMap || !((_a = datasheetService.instance) === null || _a === void 0 ? void 0 : _a.checkRoomExist())) {
            return;
        }
        const previousWidgetIds = widgetIds;
        widgetIds = new Set(Object.keys(widgetMap).filter(item => Boolean(widgetMap[item].widget)));
        if ((0, datasheet_map_1.eqSet)(widgetIds, previousWidgetIds)) {
            return;
        }
        const diffOfAdd = (0, lodash_1.difference)([...widgetIds], [...previousWidgetIds]);
        const diffOfDelete = (0, lodash_1.difference)([...previousWidgetIds], [...widgetIds]);
        if (diffOfAdd.length) {
            for (const v of diffOfAdd) {
                datasheetService.instance.createCollaEngine(v, core_1.ResourceType.Widget);
            }
        }
        if (diffOfDelete.length) {
            for (const v of diffOfDelete) {
                datasheetService.instance.reset(v, core_1.ResourceType.Widget);
            }
        }
    });
};
exports.subscribeWidgetMap = subscribeWidgetMap;
